
























import { Component, Vue, Prop } from 'vue-property-decorator';
import DocumentControls from '@/components/Invoicing/Shared/DocumentControls.vue';
import { CREATE_RECURRING_ORDER } from '@/queries/RecurringOrder';
import { formatRecurringOrderDataForMutation } from '@/app/RecurringOrder';
import { GQL_recurringOrder_recurringOrder } from '@/queries/__generated__/recurringOrder';
import Order from '@/components/Invoicing/Order/Order.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_createRecurringOrder } from '@/queries/__generated__/createRecurringOrder';

@Component({
  components: {
    DocumentControls,
  },
})
export default class RecurringOrderNewControls extends Vue {
  private CREATE_RECURRING_ORDER = CREATE_RECURRING_ORDER;

  @Prop(Object) private order!: GQL_recurringOrder_recurringOrder;
  @Prop(Boolean) private validForm!: boolean;
  @Prop(Object) private orderRef!: Order;

  private recurringOrderCreated(_: InMemoryCache, { data }: { data: GQL_createRecurringOrder }) {
    this.resetFormDirty();

    this.$sMessage.success(this.$t('Message.saveSuccess'));
    this.$router.push({
      name: 'RecurringOrdersEdit',
      params: { id: data.createRecurringOrder!.recurringOrder!.id },
    });
  }

  private save(mutate: Function) {
    this.$emit(`save-button-click`);
    // We want to remove empty lines before saving.
    // However if we remove empty lines we trigger calculations to happen
    // in the next tick. This is why delay mutating by doing it in setTimeout.
    // This makes it be called after the calculations.
    setTimeout(() => {
      mutate({ variables: formatRecurringOrderDataForMutation({ order: this.order }) });
    }, 0);
  }

   private resetFormDirty() {
    this.$emit(`reset-form-dirty`);
  }
}
